export default "__VITE_PUBLIC_ASSET__e320c50d__"